<template>
  <v-card class="text-xs-center">
    <div style="position: relative;" class="mt-3">
      <v-btn
        icon
        style=";position:absolute;top:0px;left:10px;"
        @click="$router.back()"
      >
        <v-icon> arrow_back</v-icon></v-btn
      >
      <h1 class="text-pagename">Request Cash Log Table</h1>
    </div>

    <requestCashTable />
  </v-card>
</template>

<script>
import requestCashTable from "@/components/back-office/Rider/RequestCash/RequestCashLogTable.vue";
export default {
  components: {
    requestCashTable,
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Customer Management",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style></style>
